module.exports = __webpack_public_path__ + "img/back_button.5dd23845.svg";